import React, { useEffect, useState } from 'react';
import TableBody from './tableBody';
import Typo from 'components/ui/typo';
import Button from 'components/ui/button';
import NoDataFound from '../noDataFound';

const Table = ({
  extraKeyPosition,
  tableConfig,
  tableData = [],
  tblNoData,
  isTableHead = true,
  tblLoadMore,
  updateClient,
  selected,
  handleChange,
  maxLevel = null,
  activeDropDown,
  matchStatus,
  selfUser,
  lbObj,
  legSettingPage,
  tableBtnFunc,
  onRowClick,
  handleOtherUserTeamOverlay,
  tableheader
}) => {
  const [elementsToShow, setElementsToShow] = useState(Math.min(tblLoadMore, tableData.length));

  useEffect(() => {
    setElementsToShow(Math.min(tblLoadMore, tableData.length));
  }, [tableData, tblLoadMore]);

  const handleLoadMore = () => {
    setElementsToShow((prev) => Math.min(prev + tblLoadMore, tableData.length));
  };

  return (
    <>
      <div className='si-tbl'>
        {isTableHead && (
          <div className='si-tbl__head'>
            <div className='si-tbl__row'>
              {tableConfig?.map((tableCell, index) => (
                <div key={index} className={`si-tbl__cell si-tbl__cell--${tableCell.cls}`}>
                  {tableCell.transKey ? (
                    <Typo component={'span'} transkey={tableCell.transKey}>
                      {tableCell.title}
                    </Typo>
                  ) : (
                    <span>{tableCell.title}</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        <TableBody
          tableData={tblLoadMore ? tableData?.slice(0, elementsToShow) : tableData}
          tableConfig={tableConfig}
          extraKeyPosition={extraKeyPosition}
          activeDropDown={activeDropDown}
          matchStatus={matchStatus}
          selfUser={selfUser}
          lbObj={lbObj}
          legSettingPage={legSettingPage}
          tableBtnFunc={tableBtnFunc}
          onRowClick={onRowClick}
          handleOtherUserTeamOverlay={handleOtherUserTeamOverlay}
        />
      </div>

      {!tableData.length && <NoDataFound {...tblNoData} />}

      {elementsToShow < tableData.length && tableData.length > 0 && (
        <div className='si-tbl__loadMore'>
          <Button variant='secondary' transKey='cta_load_more' onClick={handleLoadMore}>
            Load More
          </Button>
        </div>
      )}
    </>
  );
};

export default Table;
